/**
 * <locale-switcher> — English / हिन्दी / मराठी / संस्कृतम्.
 *
 * Switching locale reloads the string bundle and re-renders the open page.
 *
 * © Manish Jagdish Thatte
 */

import { LOCALES } from '../config.js';
import { getSettings, setSetting, subscribe } from '../store.js';

const NAMES = { en: 'English', hi: 'हिन्दी', mr: 'मराठी', sa: 'संस्कृतम्' };

export class LocaleSwitcher extends HTMLElement {
  connectedCallback() {
    if (this._built) return;
    this._built = true;
    this.render();
    this._unsub = subscribe('settings.locale', () => this.render());
  }

  disconnectedCallback() {
    this._unsub?.();
  }

  render() {
    this.textContent = '';
    const current = getSettings().locale;

    const label = document.createElement('label');
    label.className = 'visually-hidden';
    label.setAttribute('for', 'locale-select');
    label.textContent = 'Language';

    const select = document.createElement('select');
    select.id = 'locale-select';
    select.className = 'locale-switcher';
    for (const id of LOCALES) {
      const opt = document.createElement('option');
      opt.value = id;
      opt.textContent = NAMES[id] ?? id;
      opt.lang = id;
      if (id === current) opt.selected = true;
      select.append(opt);
    }
    select.addEventListener('change', () => {
      // Clear any leftover browser-translate preference from earlier builds.
      setSetting('browserLang', null);
      setSetting('locale', select.value);
    });
    this.append(label, select);
  }
}

customElements.define('locale-switcher', LocaleSwitcher);
